/* Polar-Commerce: drobne rozszerzenia motywu (backup theme) */
(function () {
  function initTestimonials() {
    document.querySelectorAll('.testimonials__text').forEach(function (el) {
      if (el.dataset.lbDone) return;
      el.dataset.lbDone = '1';
      el.classList.add('lb-clamp');
      if (el.textContent.trim().length > 220) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lb-read-more';
        b.textContent = (window.polarI18n && window.polarI18n.readMore) || 'Czytaj więcej';
        b.setAttribute('aria-expanded', 'false');
        b.addEventListener('click', function () {
          var nowClamped = el.classList.toggle('lb-clamp');
          b.textContent = nowClamped ? ((window.polarI18n && window.polarI18n.readMore) || 'Czytaj więcej') : ((window.polarI18n && window.polarI18n.collapse) || 'Zwiń');
          b.setAttribute('aria-expanded', nowClamped ? 'false' : 'true');
        });
        el.insertAdjacentElement('afterend', b);
      }
    });
    var sec = document.querySelector('[id$="__testimonials_polar_opinie"] .testimonials');
    if (sec && !sec.querySelector('.lb-all-reviews')) {
      var a = document.createElement('a');
      a.href = '/pages/opinie';
      a.className = 'lb-all-reviews';
      a.textContent = (window.polarI18n && window.polarI18n.allReviews) || 'Zobacz wszystkie opinie';
      sec.appendChild(a);
    }
  }
  if (document.readyState !== 'loading') initTestimonials();
  else document.addEventListener('DOMContentLoaded', initTestimonials);
})();

/* Koszyk: checkbox regulaminu (gate checkoutu) + upsell 1-klik */
(function () {
  var KEY = 'lbTermsOk';
  function accepted() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setAccepted(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }
  function syncTermsUI() {
    var has = document.querySelector('[data-cart-terms]');
    document.querySelectorAll('[data-cart-terms]').forEach(function (box) { box.checked = accepted(); });
    document.querySelectorAll('.cart__ctas').forEach(function (w) {
      w.classList.toggle('lb-terms-off', !!has && !accepted());
    });
  }
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-cart-terms]');
    if (!box) return;
    setAccepted(box.checked);
    if (box.checked) document.querySelectorAll('[data-cart-terms-error]').forEach(function (el) { el.hidden = true; });
    syncTermsUI();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart__checkout-button');
    if (!btn) return;
    if (document.querySelector('[data-cart-terms]') && !accepted()) {
      e.preventDefault();
      e.stopPropagation();
      document.querySelectorAll('[data-cart-terms-error]').forEach(function (el) { el.hidden = false; });
    }
  }, true);
  ['cart:change', 'variant:add', 'line-item:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(syncTermsUI, 60); });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();
    btn.setAttribute('disabled', '');
    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (drawer && drawer.renderContents && state.sections) {
        drawer.renderContents(state);
        setTimeout(syncTermsUI, 120);
      } else {
        window.location.reload();
      }
    }).catch(function () { btn.removeAttribute('disabled'); });
  });
  if (document.readyState !== 'loading') syncTermsUI();
  else document.addEventListener('DOMContentLoaded', syncTermsUI);
})();

/* PDP: sticky CTA - widoczne po zescrollowaniu za buy box */
(function () {
  function initSticky() {
    var bar = document.querySelector('[data-pdp-sticky]');
    if (!bar) return;
    document.body.appendChild(bar);
    var main = document.querySelector('[id$="__main"]');
    if (!main) { bar.hidden = true; return; }
    var ticking = false;
    function update() {
      ticking = false;
      var r = main.getBoundingClientRect();
      bar.hidden = r.bottom > 120;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }
  if (document.readyState !== 'loading') initSticky();
  else document.addEventListener('DOMContentLoaded', initSticky);
})();
